import {Controller} from "stimulus";

export default class extends Controller {

  recalculateSchedule(e) {
    const currentTarget = e.target;
    const parent_id = currentTarget.dataset.parent;
    const interestRate = parseFloat(document.querySelector("[data-id='interest_rate']").innerHTML.replace(/[^0-9.]/g, ''));
    const interestForTheYear = (interestRate / 12) / 100;
    const rows = this.element.getElementsByClassName('schedule_row');
    const parentRow = this.element.querySelector(`[data-id='${parent_id}']`);
    const rowPeriod = Date.parse(parentRow.querySelector("[data-id='period']").innerHTML);
    let changedClosingAmount = 0;

    Array.from(rows).forEach((row, index, rows) => {
      let period = Date.parse(row.querySelector("[data-id='period']").innerHTML);
      if (period >= rowPeriod) {
        let openingBalance = row.querySelector("[data-id='opening_balance']").children[0].innerHTML;
        let openingAmount = parseFloat(row.querySelector("[data-id='opening_balance']").children[0].innerHTML.replace(/[^0-9.]/g, ''));
        let principal = row.querySelector("[data-id='principal']");
        let interest = row.querySelector("[id='interest']").children[0];
        let principalAmount = parseFloat(row.querySelector("[data-id='principal']").value.replace(/[^0-9.]/g, ''));
        let interestAmount = parseFloat(interest.innerHTML.replace(/[^0-9.]/g, ''));
        let emiAmount = parseFloat(row.querySelector("[data-id='emi_amount']").children[0].innerHTML.replace(/[^0-9.]/g, ''));
        let emi = row.querySelector("[data-id='emi_amount']").children[0];
        let closingBalance = row.querySelector("[data-id='closing_balance']").children[0] !== undefined ? row.querySelector("[data-id='closing_balance']").children[0] : row.querySelector("[data-id='closing_balance']");
        let closingAmount = `${(openingAmount - principalAmount).toFixed(2)}`

        if (row === parentRow) {
          emi.innerHTML = `${(principalAmount + interestAmount).toFixed(2)}`;
          closingBalance.innerHTML = closingAmount;
          changedClosingAmount = parseFloat(closingAmount);
        } else if (index === (rows.length - 1)) {
          let interestForPeriod = (openingAmount * interestForTheYear);
          interest.innerHTML = `${interestForPeriod.toFixed(2)}`;
          principal.value = `${(openingAmount - interestForPeriod).toFixed(2)}`;
          emi.innerHTML = `${(openingAmount).toFixed(2)}`;
          closingBalance.innerHTML = `${(openingAmount - parseFloat(emi.innerHTML)).toFixed(2)}`;
        } else {
          let interestForPeriod = (openingAmount * interestForTheYear);
          interest.innerHTML = `${interestForPeriod.toFixed(2)}`;
          principal.value = `${(emiAmount - interestForPeriod).toFixed(2)}`;
          emi.innerHTML = `${emiAmount}`;
          closingBalance.innerHTML = `${(openingAmount - (emiAmount - interestForPeriod)).toFixed(2)}`;
        }

        if (rows[index + 1] !== undefined) {
          rows[index + 1].querySelector("[data-id='opening_balance']").children[0].innerHTML = closingAmount
        }

        row.querySelector('#changed_schedules__opening_balance').value = openingAmount;
        row.querySelector('#changed_schedules__interest').value = (openingAmount * interestForTheYear);
        row.querySelector('#changed_schedules__closing_balance').value = (openingAmount - (emiAmount - (openingAmount * interestForTheYear))).toFixed(2);
      }
    })
  }

  change_period(e) {
    let default_date = new Date(e.target.dataset.defaultDate);
    let current_date = new Date(e.target.value);
    let difference = (current_date.getFullYear()*12 + current_date.getMonth()) - (default_date.getFullYear()*12 + default_date.getMonth());
    let default_start_date = new Date(document.querySelector("[data-id='start_date']").value);
    const rows = document.getElementsByClassName('schedule_row');
    let length = rows.length

    const uncategorized = document.getElementsByClassName('uncategorized');
    let unCategorizedLength = Array.from(uncategorized).length

    let actual_start_date = new Date(document.querySelector("[data-id='actual_start_date']").defaultValue);
    let actual_start_date_year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(actual_start_date);

    let current_date_year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(current_date);
    const interestRate = parseFloat(document.querySelector("[id='interest_rate']").value.replace(/[^0-9.]/g, ''));

    let interest_for_year =    (interest_rate.value / 12) / 100

    let openingAmount = document.querySelector("[data-id='opening_balance']").children[0].innerHTML;
    let openingBalance = parseFloat(openingAmount.replace(/[^0-9.]/g, ''));

    let emi_amount = ((openingBalance * interest_for_year) / (1 - ((1 + interest_for_year) ** (-1 * (unCategorizedLength + difference)  * 1))))

    Array.from(uncategorized).forEach((row, index, uncategorized) => {
       let newScheduleLine = document.querySelector("[data-parent='newScheduleLine']")
         if (newScheduleLine !== null){
            newScheduleLine.remove();
         }
       let emi = row.querySelector("[data-id='emi_amount']").children[0];
       const currentTarget = e.target;
       const parent_id = currentTarget.dataset.parent;
       const parentRow = this.element.querySelector(`[data-id='${parent_id}']`);
       let openingBalance = row.querySelector("[data-id='opening_balance']").children[0].innerHTML;
       let openingAmount = parseFloat(openingBalance.replace(/[^0-9.]/g, ''));
       let principal = row.querySelector("[data-id='principal']");
       let interest = row.querySelector("[id='interest']").children[0];
       let principalAmount = parseFloat(principal.value.replace(/[^0-9.]/g, ''));
       let interestAmount = parseFloat(interest.innerHTML.replace(/[^0-9.]/g, ''));
       let closingBalance = row.querySelector("[data-id='closing_balance']").children[0] !== undefined ? row.querySelector("[data-id='closing_balance']").children[0] : row.querySelector("[data-id='closing_balance']");
       let closingAmount = `${(openingAmount - principalAmount).toFixed(2)}`;

        let interestForPeriod = (openingAmount * interest_for_year);
        interest.innerHTML = `${interestForPeriod.toFixed(2)}`;
        principal.value = `${(emi_amount - interestForPeriod).toFixed(2)}`;
        emi.innerHTML = `${(emi_amount).toFixed(2)}`;
        closingBalance.innerHTML = `${(openingAmount - (emi_amount - interestForPeriod)).toFixed(2)}`;

        if (uncategorized[index + 1] !== undefined) {
          uncategorized[index + 1].querySelector("[data-id='opening_balance']").children[0].innerHTML = closingBalance.innerHTML
        }
        row.querySelector('#changed_schedules__opening_balance').value = openingAmount;
        row.querySelector('#changed_schedules__interest').value = interestForPeriod;
        row.querySelector('#changed_schedules__closing_balance').value = (openingAmount - (emi_amount - interestForPeriod)).toFixed(2);
    })

    let get_schedule = document.getElementById("schedule_container");
    let lastElement = uncategorized[uncategorized.length - 1]
    let lastClosingAmount = parseFloat(lastElement.querySelector("[data-id='closing_balance']").innerHTML.replace(/[^0-9.]/g, ''))


    for (var i = 0; i < difference; i++) {
      let row_length = (row_length)
      get_schedule.insertAdjacentHTML('beforeend',
      newScheduleLine(lastClosingAmount, emi_amount, row_length, i, default_date, interest_for_year, difference,default_start_date));
      lastClosingAmount = (lastClosingAmount - (emi_amount - (lastClosingAmount * interest_for_year)));
    }
  }
}

function truncate(number) {
  const flooredNumber = Math.floor(number * 100)
  return flooredNumber/100;
}

function date_format(date){
  let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
  let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
  let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
  return `${da} ${mo} ${ye}`;
}

function newScheduleLine(openingBalance, emi_amount,row_length,i,default_date,interest_for_year,difference,default_start_date) {
    let openingAmount = openingBalance;
    let interestForPeriod = (openingAmount * interest_for_year);
    let interest = interestForPeriod;
    let principal = (emi_amount - interestForPeriod);
    let closingBalance = (openingAmount - principal);

return `
        <div class="columns schedule_row" data-id="row_${i + 1 }" data-parent= "newScheduleLine" style= "border-bottom: 0.5px solid #B2B5BA;border-top: 0px solid #B2B5BA">
        <div class="column column_row" data-parent="row_${row_length - i }" data-id="period" style="text-align: left">${date_format(new Date(default_date.getFullYear(), default_date.getMonth() + i + 1, default_start_date.getDate()))}</div>
        <input value="${date_format(new Date(default_date.getFullYear(), default_date.getMonth() + difference - i, default_start_date.getDate()))}" autocomplete="off" type="hidden" name="changed_schedules[][period]" id="changed_schedules__period">

        <div class="column column_row" data-parent="row_${row_length - i }" data-id="opening_balance" style="text-align: right"><span class="positive-num">${openingBalance.toFixed(2)}</span></div>
        <input value=${openingBalance.toFixed(2)} autocomplete="off" type="hidden" name="changed_schedules[][opening_balance]" id="changed_schedules__opening_balance">

        <div class="column column_row" style="text-align: right">
           <input value=${principal.toFixed(2)} class="input" style="text-align: right;font-size: 14px; padding: 0 5px 0 0" placeholder="Amount" data-id="principal" data-action="change->emi-schedule#recalculateSchedule" data-type="float" data-parent="row_${row_length - i }" required="required" type="number" min="" name="changed_schedules[][principal]" id="changed_schedules__principal">
        </div>

        <div class="column column_row" data-parent="row_${row_length - i }" data-id="interest" style="text-align: right"><span class="positive-num">${interest.toFixed(2)}</span></div>
        <input value=${interest.toFixed(2)} autocomplete="off" type="hidden" name="changed_schedules[][interest]" id="changed_schedules__interest">

        <div class="column column_row" data-parent="row_${row_length - i }" data-id="emi_amount" style="text-align: right"><span class="positive-num">${emi_amount.toFixed(2)}</span></div>

        <div class="column column_row" data-parent="row_${row_length - i }" data-id="closing_balance" style="text-align: right">${((i + 1) === difference) ? 0 : closingBalance.toFixed(2)}</div>
        <input value=${((i + 1) === difference) ? 0 : closingBalance.toFixed(2)} autocomplete="off" type="hidden" name="changed_schedules[][closing_balance]" id="changed_schedules__closing_balance">

        <div class="column column_row" data-parent="row_${row_length - i }" data-id="status" style="text-align: center">
            <span class="tag is-success" style="margin-right: 1em;background:rgba(32, 201, 172, 0.1);font-weight: 400;color: #20C9AC;">Scheduled</span>
        </div>
      </div>`;
}